import "./App.css";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import AddTask from "./pages/AddTask";
import EditTask from "./pages/EditTask";
import { BrowserRouter, Route, Routes } from "react-router-dom";
function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AddTask" element={<AddTask />} />
        <Route path="/EditTask/:taskId" element={<EditTask />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
